import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { apiService } from '../services/api.service';
import '../styles.css';

interface PayFastCancelParams {
  m_payment_id?: string;
  pf_payment_id?: string;
  custom_str1?: string;
}

const CancelPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [donationDetails, setDonationDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  
  // Get PayFast cancel parameters from URL
  const urlParams = new URLSearchParams(location.search);
  const payFastParams: PayFastCancelParams = {
    m_payment_id: urlParams.get('m_payment_id') || undefined,
    pf_payment_id: urlParams.get('pf_payment_id') || undefined,
    custom_str1: urlParams.get('custom_str1') || undefined,
  };

  // Get donation ID from URL params
  const donationId = urlParams.get('donation_id') || payFastParams.m_payment_id || payFastParams.custom_str1;

  useEffect(() => {
    const fetchDonationDetails = async () => {
      if (donationId) {
        try {
          const response = await apiService.getDonationById(donationId);
          if (response.success && response.data) {
            setDonationDetails(response.data);
            
            // Update donation status to cancelled
            await apiService.updatePaymentStatus(donationId, {
              paymentStatus: 'cancelled',
              transactionId: payFastParams.pf_payment_id
            });
          }
        } catch (error) {
          console.error('Error fetching donation details:', error);
        }
      }
      setLoading(false);
    };

    fetchDonationDetails();
  }, [donationId, payFastParams.pf_payment_id]);

  const scrollToDonate = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/', { replace: true });
    // Small delay to ensure navigation completes before scrolling
    setTimeout(() => {
      document.getElementById('donate')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleTryAgain = () => {
    navigate('/', { replace: true });
    // Small delay to ensure navigation completes before scrolling
    setTimeout(() => {
      document.getElementById('donate')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  if (loading) {
    return (
      <div className="page-container">
        <Navbar onDonateClick={scrollToDonate} />
        <div style={{ padding: '100px 0', textAlign: 'center' }}>
          <h2>Processing cancellation...</h2>
          <p>Please wait while we update your donation status.</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navbar onDonateClick={scrollToDonate} />
      
      <section className="success-section" style={{ backgroundColor: 'white', padding: '80px 0' }}>
        <div className="container">
          <div className="success-page-content">
{/* Donation details block hidden
            {donationDetails && (
              <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3>Cancelled Donation</h3>
                <p><strong>Donation ID:</strong> {donationDetails.donationId}</p>
                <p><strong>Amount:</strong> R{donationDetails.amount}</p>
                <p><strong>Type:</strong> {donationDetails.donationType}</p>
                <p><strong>Status:</strong> Cancelled</p>
              </div>
            )}
            */}
            
            <h1 className="success-page-title">
              Payment Cancelled - We understand that sometimes circumstances change, and we appreciate your initial intention to support our mission against malaria.
            </h1>
            
            <p className="success-page-subtitle">
              Your payment has been cancelled and no charges have been made to your account. If you'd like to try again or need assistance with your donation, we're here to help.
            </p> 

            <h2 className="success-page-section-title">
              What happened?
            </h2>
            <p className="success-page-text">
              You chose to cancel the payment process before it was completed. This could happen if you clicked the "Cancel" or "Back" button on the payment page, closed the payment window, or experienced a technical issue during payment.
            </p>

            <h2 className="success-page-section-title">
              Still want to help?
            </h2>
            <p className="success-page-text">
              Your support means everything to us in our fight against malaria. Every contribution, no matter the size, brings us closer to a malaria-free future for southern Africa. If you'd like to try again, simply click the button below.
            </p>

            <h2 className="success-page-section-title">
              Need Assistance?
            </h2>
            <p className="success-page-text">
              If you're experiencing technical difficulties or have questions about donating, please don't hesitate to contact us at support@goodbyemalaria.com or call us at +27 (0) 11 123 4567. We're here to help make your donation process as smooth as possible.
            </p>

            <div className="success-page-buttons">
              <button
                onClick={handleTryAgain}
                style={{
                  backgroundColor: 'var(--color-green)',
                  color: 'white',
                  border: 'none',
                  padding: '15px 30px',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'var(--color-background)'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'var(--color-green)'}
              >
                Try Again
              </button>
              
              <button
                onClick={() => navigate('/')}
                style={{
                  backgroundColor: 'transparent',
                  color: 'var(--color-heading)',
                  border: '2px solid var(--color-light-grey)',
                  padding: '15px 30px',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--color-light-grey)';
                  e.currentTarget.style.borderColor = 'var(--color-grey)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = 'var(--color-light-grey)';
                }}
              >
                Return Home
              </button>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default CancelPage;
